import api from './client';

export interface FieldPulseMaliTakvimItem {
  key: string;
  title: string;
  /** Y-m-d */
  date: string;
  days_left: number;
  kategori: string;
}

export interface FieldPulseData {
  report_streak_days: number;
  days_without_incident: number | null;
  mali_takvim: FieldPulseMaliTakvimItem[];
}

/** Dashboard "Saha Nabzı" kartı verisi (proje seçiliyse projeye göre). */
export async function fetchFieldPulse(projectId?: number): Promise<FieldPulseData> {
  const response = await api.get('/api/v1/dashboard/field-pulse', {
    params: projectId ? { project_id: projectId } : {},
  });
  return response.data.data;
}

export interface MaliTakvimItem {
  key: string;
  title: string;
  /** Y-m-d */
  date: string;
  days_left: number;
  kategori: string;
}

/**
 * Mali takvim detay sayfası verisi. Parametre verilmezse sunucu
 * bugün → +12 ay penceresi döner.
 */
export async function fetchMaliTakvim(params?: { start?: string; end?: string }): Promise<MaliTakvimItem[]> {
  const response = await api.get('/api/v1/mali-takvim', { params });
  return response.data.data;
}

export interface MaliTakvimDynamicItem {
  /** Dinamik vade tipi (ör. cek, teminat, taksit, belge, izin). */
  tip: string;
  title: string;
  /** Y-m-d */
  date: string;
  days_left: number;
  kategori: string;
  /** Uygulama içi hedef route (satıra tıklayınca navigate edilir). */
  url: string;
  tutar?: number | null;
}

export interface MaliTakvimFullResponse {
  data: MaliTakvimItem[];
  dynamic: MaliTakvimDynamicItem[];
}

/**
 * Mali takvim detay sayfası: statik yasal yükümlülükler + dinamik şirket
 * vadeleri (çek, teminat, taksit, belge, izin). `dynamic` anahtarı backend'e
 * sonradan eklendi; eski sunucularda yoksa boş dizi kabul edilir.
 */
export async function fetchMaliTakvimFull(params?: { start?: string; end?: string }): Promise<MaliTakvimFullResponse> {
  const response = await api.get('/api/v1/mali-takvim', { params });
  return {
    data: response.data.data ?? [],
    dynamic: response.data.dynamic ?? [],
  };
}

export interface MaliNewsItem {
  id: number | string;
  /** Kaynak anahtarı (ör. resmi_gazete, gib, sgk). */
  source: string;
  title: string;
  summary: string | null;
  /** ISO datetime */
  published_at: string;
  /** Kaynak sayfasının harici URL'i. */
  url: string;
}

/**
 * "Güncel Mali Gelişmeler" akışı: son N gündeki Resmî Gazete / GİB / SGK
 * duyuruları. Sunucu harici kaynaklara ulaşamazsa boş dizi döner.
 */
export async function fetchMaliNews(days = 30, page = 1): Promise<MaliNewsItem[]> {
  const response = await api.get('/api/v1/mali-news', { params: { days, page } });
  return response.data.data ?? [];
}

export interface MaliNewsPage {
  data: MaliNewsItem[];
  lastPage: number;
  total: number;
}

/** Sayfalı haber listesi (Mali Haberler sayfası). */
export async function fetchMaliNewsPaged(days = 30, page = 1): Promise<MaliNewsPage> {
  const response = await api.get('/api/v1/mali-news', { params: { days, page } });
  return {
    data: response.data.data ?? [],
    lastPage: response.data.last_page ?? 1,
    total: response.data.total ?? 0,
  };
}
